module.exports = __webpack_public_path__ + "static/media/banner-jp.c0bf73ac.jpg";